import type { TFileWithMeta } from '@components/Files/UploadProvider/types/TFileWithMeta';

export type TPendingMediaAnalysis = { fileId: string; jobId: string; mediaId: string; startedAt: number };

export const collectPendingMediaAnalyses = (files: TFileWithMeta[], fallbackJobId = ''): TPendingMediaAnalysis[] =>
  files.flatMap((file) => {
    const jobId = String(file.meta.extra?.jobId || fallbackJobId);
    const mediaId = String(file.meta.extra?.mediaId ?? '');
    const startedAt = Number(file.meta.extra?.analysisStartedAt) || 0;
    const isPending =
      file.meta.status !== 'removed' &&
      file.meta.extra?.analysisStatus === 'progress' &&
      jobId !== '' &&
      mediaId !== '' &&
      startedAt > 0;
    return isPending ? [{ fileId: file.meta.id, jobId, mediaId, startedAt }] : [];
  });
